import { useState } from "react";
import { ChevronDown, Plus } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { ScorePillars } from "./ScorePillars";
import { MetaAdSignal } from "./MetaAdSignal";
import { VenueContacts } from "./VenueContacts";

export const ProspectRow = ({ item, rank, groups, searchId, csrfToken, onAdded, onOpenVenue }) => {
  const [expanded, setExpanded] = useState(false);
  const [type, setType] = useState(item.activity_type || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const add = async () => {
    setBusy(true); setError("");
    try { await api.post(`/searches/${searchId}/prospects/${item.id}/add`, { activity_type: type },
      { headers: { "X-CSRF-Token": csrfToken } }); await onAdded(); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <div className={`prospect-row${rank <= 5 ? " prospect-top" : ""}`} data-testid={`prospect-row-${item.id}`}>
    <button type="button" className="prospect-summary" onClick={() => setExpanded(!expanded)}
      aria-expanded={expanded} data-testid={`prospect-toggle-${item.id}`}>
      <span className="prospect-rank">{rank < 10 ? `0${rank}` : rank}</span>
      <span className="prospect-summary-copy"><strong>{item.name}</strong><small>{item.activity_type}</small></span>
      <span className="prospect-rating">★ {item.rating?.toLocaleString("it-IT") || "0"}</span>
      <ChevronDown size={17} aria-hidden="true" /></button>
    {expanded && <div className="prospect-details" data-testid={`prospect-details-${item.id}`}>
      {item.full_name && item.full_name !== item.name && <p className="prospect-full-name" data-testid={`prospect-full-name-${item.id}`}>{item.full_name}</p>}
      <p className="prospect-address" data-testid={`prospect-address-${item.id}`}>{item.address || "Indirizzo non disponibile"}</p>
      <ScorePillars pillars={item.score_pillars} penalties={item.score_penalties} />
      <MetaAdSignal data={item.meta_ads} />
      <VenueContacts contacts={item.contacts} showGoogleMissing={Boolean(item.place_id)} testId={`prospect-${item.id}-contacts`} />
      {item.franchise_label && <p className="venue-franchise" data-testid={`prospect-franchise-${item.id}`}>{item.franchise_label}</p>}
      {item.rating_reasons?.length > 0 && <p className="prospect-reasons" data-testid={`prospect-reasons-${item.id}`}>{item.rating_reasons.join(" · ")}</p>}
      {item.added_venue_id ? <button type="button" className="hud-button hud-secondary" onClick={() => onOpenVenue(item.added_venue_id)}
        data-testid={`prospect-open-venue-${item.id}`}>Aggiunto · Apri scheda</button> : <>
        <div className="form-field"><label htmlFor={`prospect-type-${item.id}`}>AGGIUNGI IN</label>
          <select id={`prospect-type-${item.id}`} value={type} onChange={(e) => setType(e.target.value)}
            data-testid={`prospect-type-${item.id}`}><option value="">Scegli tipologia</option>
            {groups.map((group) => <optgroup key={group.id} label={`${group.id} · ${group.name}`}>
              {group.keywords.map((word) => <option key={word} value={word}>{word}</option>)}</optgroup>)}</select></div>
        <button type="button" className="hud-button" disabled={!type || busy} onClick={add}
          data-testid={`prospect-add-${item.id}`}><Plus size={18} aria-hidden="true" /> Aggiungi ai Locali · {type || "tipologia"}</button>
      </>}
      {error && <p role="alert" className="form-error" data-testid={`prospect-error-${item.id}`}>{error}</p>}
    </div>}
  </div>;
};